import { Icon } from '../icons';
import { formatDate, truncate } from '../utils';

export function Skills({ data, onSelect }) {
  return (
    <main className="skills page-view">
      <header className="page-heading"><p>Reusable skills</p><h1>Memory that can act.</h1><span>Durable workflows distilled from prior work and ready to guide the next run.</span></header>
      <div className="skill-index">
        {data.skills.map((skill, index) => (
          <button key={skill.id} onClick={() => onSelect({ ...skill, kind: 'skill', status: 'current', project: 'Reusable skill' })}>
            <span className="skill-index__number">{String(index + 1).padStart(2, '0')}</span>
            <span className="skill-index__icon"><Icon name="skills" size={24}/></span>
            <span className="skill-index__copy"><small>Reusable workflow</small><strong>{skill.title}</strong><p>{truncate(skill.description, 180)}</p><code>{skill.path}</code></span>
            <span className="skill-index__date">Updated {formatDate(skill.updatedAt)}</span>
            <Icon name="arrow" size={20}/>
          </button>
        ))}
      </div>
    </main>
  );
}
